import type { StoreDetails } from '~/declaration/bops';

export const checkCutOffTime = (options: Pick<StoreDetails, 'otherDate' | 'pickupCutOffTime'>) => {
  const { otherDate, pickupCutOffTime } = options;
  let conditionalCheck = '';
  switch (true) {
    case typeof pickupCutOffTime === 'undefined' && typeof otherDate === 'undefined':
      conditionalCheck = 'noDates';
      break;
    case typeof pickupCutOffTime !== 'undefined' && typeof otherDate === 'undefined':
      conditionalCheck = 'pickupCutOffTimeOnly';
      break;
    case typeof pickupCutOffTime === 'undefined' && typeof otherDate !== 'undefined':
      conditionalCheck = 'otherDateOnly';
      break;
    case typeof pickupCutOffTime !== 'undefined' && typeof otherDate !== 'undefined':
      conditionalCheck = 'bothDates';
      break;
    default:
      break;
  }
  return conditionalCheck;
};
